import { render, staticRenderFns } from "./CaseItemsPanel.vue?vue&type=template&id=11ac5848&scoped=true&"
import script from "./CaseItemsPanel.vue?vue&type=script&lang=js&"
export * from "./CaseItemsPanel.vue?vue&type=script&lang=js&"
import style0 from "./CaseItemsPanel.vue?vue&type=style&index=0&id=11ac5848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ac5848",
  null
  
)

export default component.exports